<template>
	<div class="container">
		<el-breadcrumb separator=">" style="margin-bottom:15px;">
			<el-breadcrumb-item :to="{ path: '/home' }">
				<div style="display: flex;align-items: center;margin-left: 15px;">
					<el-icon>
						<Location />
					</el-icon>
					<span style="margin-left: 5px;">首页</span>
				</div>
			</el-breadcrumb-item>
			<el-breadcrumb-item>个人空间</el-breadcrumb-item>
		</el-breadcrumb>
		<div style="display: flex;justify-content: space-between;margin-bottom: 15px;align-items: center;">
			<div style="font-size: 20px;color: #1764a2;">文件列表</div>
			<div>
				<el-button type="primary" icon="Plus" @click="dialogFlag=true">新增</el-button>
				<el-button type="danger" icon="Delete" :disabled="selectList.length == 0" @click="removeHandler">删除</el-button>
			</div>
		</div>
		<div style="margin-bottom: 15px;">
			<el-table v-bind="tableOptions" :data="tableData" ref="tableref" row-key="id" style="width: 100%"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center" />
				<el-table-column prop="name" label="文件名称" align="center" />
				<el-table-column prop="size" label="文件大小" align="center">
					<template #default="scope">
						<span>{{(scope.row.size/1024).toFixed(2)}}KB</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_datetime" label="创建时间" align="center" />
				<el-table-column label="操作" align="center">
					<template #default="scope">
						<el-button icon="Download" type="success" plain text size="small"
							@click="downloadFileURLByA(scope.row.file)">下载</el-button>
						<el-button icon="Delete" type="danger" plain text size="small" @click="removeRow(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="display:flex;justify-content: flex-end;margin-bottom: 30px;">
			<el-pagination background layout="total,prev, pager, next" :total="pageInfo.total" :current-page="pageInfo.page"
				@current-change="currentChange" />
		</div>
		<ly-dialog v-model="dialogFlag" title="上传文件" width="40%" :before-close="handleDialogClose">
			<div>
				<el-upload style='width:100%;' drag :http-request="fileHandler" :limit="1" :on-remove="remorveFile">
					<el-icon class="el-icon--upload"><upload-filled /></el-icon>
					<div class="el-upload__text">拖拽文件到这 或 <em>点击上传</em></div>
				</el-upload>
			</div>
			<template v-slot:footer>
				<div style="display: flex;justify-content: flex-end;">
					<el-button @click="handleDialogClose">取消</el-button>
					<el-button type="primary" @click="submitData">确定</el-button>
				</div>
			</template>
		</ly-dialog>
	</div>
</template>

<script setup>
	import {
		ref,
		reactive,
		onMounted
	} from "vue"
	import {
		downloadFileURLByA
	} from "@/utils/util"
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		fileGet,
		filePost,
		fileDelete
	} from "@/api/court"
	import LyDialog from "@/components/dialog/dialog"
	const selectList = ref([])
	const dialogFlag = ref(false)
	const file = ref("")

	const tableData = ref([])

	const pageInfo = reactive({
		search: "",
		total: 0,
		page: 1,
		limit: 10
	})

	const tableOptions = ref({
		stripe: false, // 斑马纹
		highlightCurrentRow: false, // 是否要高亮当前行
		border: true, // 是否有纵向边框
		fit: true, // 列的宽度是否自撑开
		size: 'default', // Table 的尺寸
		lazy: false, // 是否需要懒加载
		showHeader: true, //是否显示表头
		defaultExpandAll: false, //是否默认展开所有行
	})

	function initPage() {
		fileGet(pageInfo).then(res => {
			if (res.code == 2000) {
				pageInfo.total = res.data.total
				tableData.value = res.data.data
			}
		})
	}

	function currentChange(page) {
		pageInfo.page = page
		initPage()
	}

	//多选框选中的数据
	function handleSelectionChange(selection) {
		selectList.value = selection
	}

	//表格中的删除事件 所有的删除事件需要进行一次确认 直接将这一行数据放到selectList数组中
	function removeRow(data) {
		ElMessageBox.confirm('是否确认删除当前行的文件', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove([data])
		})
	}

	function removeHandler() {
		ElMessageBox.confirm('是否确认删除当前选中的文件', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove(selectList.value)
		})
	}

	function remove(arr) {
		let flags = []
		arr.map(node => {
			fileDelete(node.id).then(res => {
				if (res.code == 2000) {
					flags.push(true)
					if (flags.length == arr.length) {
						ElMessage.success("文件删除成功")
						initPage()
					}
				}
			})
		})
	}

	function handleDialogClose() {
		dialogFlag.value = false
		file.value = ""
	}

	let attachmentList = []


	function fileHandler(e) {
		file.value = e.file
	}

	//附件删除
	function remorveFile(e) {
		file.value = ""
	}

	function submitData() {
		filePost({
			file: file.value
		}).then(res => {
			if (res.code == 2000) {
				ElMessage.success("文件上传成功")
				initPage()
				handleDialogClose()
			}
		})
	}

	onMounted(_ => {
		initPage()
	})
</script>

<style lang="scss" scoped>
	.container {
		width: 1200px;
		margin: 0 auto;
		padding-top: 20px;

		:deep(.el-button--primary) {
			--el-button-bg-color: #1764a2;
			--el-button-hover-bg-color: #1764a2;
		}
	}
</style>